









import { OpcaoRadioSlider } from '@/tipos'
import Vue, { PropType } from 'vue'

type Categoria = OpcaoRadioSlider

interface Data {
  categorias: Categoria[];
  categoriaSelecionada: Categoria;
}

interface Methods {
  selecionarCategoria: (categoria: Categoria) => void;
}

interface Computed {
  indiceSelecionado: number;
}

interface Props {
  value: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'TipoObservado',

  props: {
    value: {
      type: String as PropType<string>,
      required: true
    }
  },

  computed: {
    indiceSelecionado (): number {
      const {categoriaSelecionada, categorias} = this
      return categorias.findIndex(i => i.id === categoriaSelecionada.id)
    }
  },

  data () {
    return {
      categoriaSelecionada: { name: this.$wp('company'), id: 'locaisDeTrabalhoObservados', common: 'companies' },
      categorias: [
        { name: this.$wp('company'), id: 'locaisDeTrabalhoObservados', common: 'companies' },
        { name: this.$wp('employee'), id: 'funcionariosObservados', common: 'employees' },
        { name: 'grupos', id: 'gruposDeUsuarioObservados', common: 'userGroups' }
      ]
    }
  },

  methods: {
    selecionarCategoria (categoria: Categoria): void {
      this.categoriaSelecionada = categoria
      this.$emit('input', categoria.id)
    }
  }
})
